import { render, staticRenderFns } from "./Axis.md?vue&type=template&id=7b64a5d3&"
import script from "./Axis.md?vue&type=script&lang=js&"
export * from "./Axis.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b64a5d3')) {
      api.createRecord('7b64a5d3', component.options)
    } else {
      api.reload('7b64a5d3', component.options)
    }
    module.hot.accept("./Axis.md?vue&type=template&id=7b64a5d3&", function () {
      api.rerender('7b64a5d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/doc/plugins/Axis.md"
export default component.exports